export const candidateInterviewConstants = {
  //view assigned interview kit
  VIEW_ASSIGNED_INTERVIEW_KIT_CANDIDATE_ACTION_REQUEST:
    "VIEW_ASSIGNED_INTERVIEW_KIT_CANDIDATE_ACTION_REQUEST",
  VIEW_ASSIGNED_INTERVIEW_KIT_CANDIDATE_ACTION_SUCCESS:
    "VIEW_ASSIGNED_INTERVIEW_KIT_CANDIDATE_ACTION_SUCCESS",
  VIEW_ASSIGNED_INTERVIEW_KIT_CANDIDATE_ACTION_FAILURE:
    "VIEW_ASSIGNED_INTERVIEW_KIT_CANDIDATE_ACTION_FAILURE",

  //get practice questions
  GET_PRACTICE_INTERVIEW_QUESTION_DETAILS_CANDIDATE_ACTION_REQUEST:
    "GET_PRACTICE_INTERVIEW_QUESTION_DETAILS_CANDIDATE_ACTION_REQUEST",
  GET_PRACTICE_INTERVIEW_QUESTION_DETAILS_CANDIDATE_ACTION_SUCCESS:
    "GET_PRACTICE_INTERVIEW_QUESTION_DETAILS_CANDIDATE_ACTION_SUCCESS",
  GET_PRACTICE_INTERVIEW_QUESTION_DETAILS_CANDIDATE_ACTION_FAILURE:
    "GET_PRACTICE_INTERVIEW_QUESTION_DETAILS_CANDIDATE_ACTION_FAILURE",

  //get assigned questions
  GET_ASSIGNED_INTERVIEW_QUESTION_DETAILS_CANDIDATE_ACTION_REQUEST:
    "GET_ASSIGNED_INTERVIEW_QUESTION_DETAILS_CANDIDATE_ACTION_REQUEST",
  GET_ASSIGNED_INTERVIEW_QUESTION_DETAILS_CANDIDATE_ACTION_SUCCESS:
    "GET_ASSIGNED_INTERVIEW_QUESTION_DETAILS_CANDIDATE_ACTION_SUCCESS",
  GET_ASSIGNED_INTERVIEW_QUESTION_DETAILS_CANDIDATE_ACTION_FAILURE:
    "GET_ASSIGNED_INTERVIEW_QUESTION_DETAILS_CANDIDATE_ACTION_FAILURE",

  //upload url questions
  GET_MUX_INTERVIEW_VIDEO_UPLOAD_URL_CANDIDATE_ACTION_REQUEST:
    "GET_MUX_INTERVIEW_VIDEO_UPLOAD_URL_CANDIDATE_ACTION_REQUEST",
  GET_MUX_INTERVIEW_VIDEO_UPLOAD_URL_CANDIDATE_ACTION_SUCCESS:
    "GET_MUX_INTERVIEW_VIDEO_UPLOAD_URL_CANDIDATE_ACTION_SUCCESS",
  GET_MUX_INTERVIEW_VIDEO_UPLOAD_URL_CANDIDATE_ACTION_FAILURE:
    "GET_MUX_INTERVIEW_VIDEO_UPLOAD_URL_CANDIDATE_ACTION_FAILURE",

  //asset playback ids questions
  GET_MUX_INTERVIEW_VIDEO_UPLOAD_PLAYBACK_ID_CANDIDATE_ACTION_REQUEST:
    "GET_MUX_INTERVIEW_VIDEO_UPLOAD_PLAYBACK_ID_CANDIDATE_ACTION_REQUEST",
  GET_MUX_INTERVIEW_VIDEO_UPLOAD_PLAYBACK_ID_CANDIDATE_ACTION_SUCCESS:
    "GET_MUX_INTERVIEW_VIDEO_UPLOAD_PLAYBACK_ID_CANDIDATE_ACTION_SUCCESS",
  GET_MUX_INTERVIEW_VIDEO_UPLOAD_PLAYBACK_ID_CANDIDATE_ACTION_FAILURE:
    "GET_MUX_INTERVIEW_VIDEO_UPLOAD_PLAYBACK_ID_CANDIDATE_ACTION_FAILURE",

  //candidate Interview Video
  INTERVIEW_VIDEO_UPLOAD_ID_CANDIDATE_ACTION_REQUEST:
    "INTERVIEW_VIDEO_UPLOAD_ID_CANDIDATE_ACTION_REQUEST",
  INTERVIEW_VIDEO_UPLOAD_ID_CANDIDATE_ACTION_SUCCESS:
    "INTERVIEW_VIDEO_UPLOAD_ID_CANDIDATE_ACTION_SUCCESS",
  INTERVIEW_VIDEO_UPLOAD_ID_CANDIDATE_ACTION_FAILURE:
    "INTERVIEW_VIDEO_UPLOAD_ID_CANDIDATE_ACTION_FAILURE",

  //candidate review Interview kit
  REVIEW_INTERVIEW_KIT_CANDIDATE_ACTION_REQUEST:
    "REVIEW_INTERVIEW_KIT_CANDIDATE_ACTION_REQUEST",
  REVIEW_INTERVIEW_KIT_CANDIDATE_ACTION_SUCCESS:
    "REVIEW_INTERVIEW_KIT_CANDIDATE_ACTION_SUCCESS",
  REVIEW_INTERVIEW_KIT_CANDIDATE_ACTION_FAILURE:
    "REVIEW_INTERVIEW_KIT_CANDIDATE_ACTION_FAILURE",

  //interview submit request

  INTERVIEW_SUBMIT_REQUEST_GET_CANDIDATE_ACTION_REQUEST:
    "INTERVIEW_SUBMIT_REQUEST_GET_CANDIDATE_ACTION_REQUEST",
  INTERVIEW_SUBMIT_REQUEST_GET_CANDIDATE_ACTION_SUCCESS:
    "INTERVIEW_SUBMIT_REQUEST_GET_CANDIDATE_ACTION_SUCCESS",
  INTERVIEW_SUBMIT_REQUEST_GET_CANDIDATE_ACTION_FAILURE:
    "INTERVIEW_SUBMIT_REQUEST_GET_CANDIDATE_ACTION_FAILURE",

  INTERVIEW_SUBMIT_REQUEST_UPDATE_CANDIDATE_ACTION_REQUEST:
    "INTERVIEW_SUBMIT_REQUEST_UPDATE_CANDIDATE_ACTION_REQUEST",
  INTERVIEW_SUBMIT_REQUEST_UPDATE_CANDIDATE_ACTION_SUCCESS:
    "INTERVIEW_SUBMIT_REQUEST_UPDATE_CANDIDATE_ACTION_SUCCESS",
  INTERVIEW_SUBMIT_REQUEST_UPDATE_CANDIDATE_ACTION_FAILURE:
    "INTERVIEW_SUBMIT_REQUEST_UPDATE_CANDIDATE_ACTION_FAILURE",

  INTERVIEW_SUBMIT_REQUEST_CREATE_CANDIDATE_ACTION_REQUEST:
    "INTERVIEW_SUBMIT_REQUEST_CREATE_CANDIDATE_ACTION_REQUEST",
  INTERVIEW_SUBMIT_REQUEST_CREATE_CANDIDATE_ACTION_SUCCESS:
    "INTERVIEW_SUBMIT_REQUEST_CREATE_CANDIDATE_ACTION_SUCCESS",
  INTERVIEW_SUBMIT_REQUEST_CREATE_CANDIDATE_ACTION_FAILURE:
    "INTERVIEW_SUBMIT_REQUEST_CREATE_CANDIDATE_ACTION_FAILURE",

  //
  GET_RECENTLY_ASSIGNED_ASSESSMENT_KITS_LIST_CANDIDATE_ACTION_REQUEST:
    "GET_RECENTLY_ASSIGNED_ASSESSMENT_KITS_LIST_CANDIDATE_ACTION_REQUEST",
  GET_RECENTLY_ASSIGNED_ASSESSMENT_KITS_LIST_CANDIDATE_ACTION_SUCCESS:
    "GET_RECENTLY_ASSIGNED_ASSESSMENT_KITS_LIST_CANDIDATE_ACTION_SUCCESS",
  GET_RECENTLY_ASSIGNED_ASSESSMENT_KITS_LIST_CANDIDATE_ACTION_FAILURE:
    "GET_RECENTLY_ASSIGNED_ASSESSMENT_KITS_LIST_CANDIDATE_ACTION_FAILURE",


  //
  ACCEPT_ASSIGNED_ASSESSMENT_KIT_CANDIDATE_ACTION_REQUEST:
    "ACCEPT_ASSIGNED_ASSESSMENT_KIT_CANDIDATE_ACTION_REQUEST",
  ACCEPT_ASSIGNED_ASSESSMENT_KIT_CANDIDATE_ACTION_SUCCESS:
    "ACCEPT_ASSIGNED_ASSESSMENT_KIT_CANDIDATE_ACTION_SUCCESS",
  ACCEPT_ASSIGNED_ASSESSMENT_KIT_CANDIDATE_ACTION_FAILURE:
    "ACCEPT_ASSIGNED_ASSESSMENT_KIT_CANDIDATE_ACTION_FAILURE",

  //
  ACCEPT_ASSIGNED_ASSESSMENT_KIT_DETAILS_CANDIDATE_ACTION_REQUEST:
    "ACCEPT_ASSIGNED_ASSESSMENT_KIT_DETAILS_CANDIDATE_ACTION_REQUEST",
  ACCEPT_ASSIGNED_ASSESSMENT_KIT_DETAILS_CANDIDATE_ACTION_SUCCESS:
    "ACCEPT_ASSIGNED_ASSESSMENT_KIT_DETAILS_CANDIDATE_ACTION_SUCCESS",
  ACCEPT_ASSIGNED_ASSESSMENT_KIT_DETAILS_CANDIDATE_ACTION_FAILURE:
    "ACCEPT_ASSIGNED_ASSESSMENT_KIT_DETAILS_CANDIDATE_ACTION_FAILURE",

  //
  GET_JOBS_LINKED_WITH_ASSIGNED_ASSESSMENT_KIT_CANDIDATE_ACTION_REQUEST:
    "GET_JOBS_LINKED_WITH_ASSIGNED_ASSESSMENT_KIT_CANDIDATE_ACTION_REQUEST",
  GET_JOBS_LINKED_WITH_ASSIGNED_ASSESSMENT_KIT_CANDIDATE_ACTION_SUCCESS:
    "GET_JOBS_LINKED_WITH_ASSIGNED_ASSESSMENT_KIT_CANDIDATE_ACTION_SUCCESS",
  GET_JOBS_LINKED_WITH_ASSIGNED_ASSESSMENT_KIT_CANDIDATE_ACTION_FAILURE:
    "GET_JOBS_LINKED_WITH_ASSIGNED_ASSESSMENT_KIT_CANDIDATE_ACTION_FAILURE",
};
